import React, { useEffect, useState } from 'react'
import { Box, Container, Typography } from '@material-ui/core'
import { useStyles } from '../../Lost_style'
import Button from 'shared/components/Button/Button.jsx'
import RouteMap from 'assets/RouteMap.js'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import SchoolAPI from 'api/SchoolAPI'
import SchoolCard from 'cards/SchoolCard/SchoolCard'
import { FormattedMessage } from 'react-intl'
import HorizontalCardsSlider from 'components/HorizontalCardsSlider/HorizontalCardsSlider'

const LostRecommendedSchools = (props) => {
    const classes = useStyles()
    const { school } = props
    const [similarSchools, setSimilarSchools] = useState([])
    const moreItemsUrl = RouteMap.Index('education')

    useEffect(() => {
        const data = {
            school_id: school?.id
        }
        SchoolAPI.GetSimilarSchools(data).then((response) => {
            setSimilarSchools(response.data.similar_schools)
        })
    }, [school])

    return (
        <Container maxWidth='lg'>
            <Typography className={classes.subsubtitle} variant='h3' component='p'>
                <FormattedMessage id='similar_schools.title' />
            </Typography>
            <Box className={classes.recommendationBox}>
                <HorizontalCardsSlider shift={300} wrappedArrows>
                    {similarSchools.map(school => {
                        return (
                            <Box key={school.id} className={classes.schoolCardBox}>
                                <SchoolCard school={school} />
                            </Box>
                        )
                    })}
                </HorizontalCardsSlider>
            </Box>
            <Box className={classes.schoolButtonContainer}>
                <RouteMapLink redirectionUrl={moreItemsUrl}>
                    <Button variant='cta-primary'>
                        <FormattedMessage id='similar_schools.button' />
                    </Button>
                </RouteMapLink>
            </Box>
        </Container>
    )
}

export default LostRecommendedSchools 